var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import style from './menulist/HeaderMenuButton.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
import AppService from '../utils/AppService';
import { addUtmParam } from '../utils/addUtmParam';
export default function AccountCartButton() {
    var _a, _b, _c, _d;
    var _e = useAperzaUserContext(), user = _e.user, serviceType = _e.serviceType;
    var _f = useState(false), isActive = _f[0], setIsActive = _f[1];
    return (_jsx("div", { children: _jsx("button", __assign({ type: "button", className: style.button, onClick: function () {
                window.location.href = addUtmParam("".concat(AppService.orderServerHost(), "/cart"), 'header', serviceType);
            }, style: { width: 44 }, onMouseEnter: function () { return !isActive && setIsActive(true); }, onMouseLeave: function () { return isActive && setIsActive(false); } }, { children: _jsx(HeaderMenuIconButton, { label: "\u30AB\u30FC\u30C8", icon: ((_a = user === null || user === void 0 ? void 0 : user.cartBadge) === null || _a === void 0 ? void 0 : _a.totalPurchaseNumber) && ((_b = user === null || user === void 0 ? void 0 : user.cartBadge) === null || _b === void 0 ? void 0 : _b.totalPurchaseNumber) > 0
                    ? "".concat(AppService.staticServerHost(), "/common/images/header/cart_dot.svg")
                    : "".concat(AppService.staticServerHost(), "/common/images/header/cart.svg"), iconHover: ((_c = user === null || user === void 0 ? void 0 : user.cartBadge) === null || _c === void 0 ? void 0 : _c.totalPurchaseNumber) && ((_d = user === null || user === void 0 ? void 0 : user.cartBadge) === null || _d === void 0 ? void 0 : _d.totalPurchaseNumber) > 0
                    ? "".concat(AppService.staticServerHost(), "/common/images/header/cart_red_dot.svg")
                    : "".concat(AppService.staticServerHost(), "/common/images/header/cart_red.svg"), isActive: isActive }) })) }));
}
